/** Only counts active requests. No request body or customer details enter this store. */
export function createWriteActivity() {
  let count = 0; const listeners = new Set<() => void>();
  const notify = () => listeners.forEach(fn => fn());
  return {
    snapshot: () => count,
    subscribe: (fn: () => void) => { listeners.add(fn); return () => { listeners.delete(fn); }; },
    begin: () => {
      count++; notify(); let ended = false;
      return () => { if (!ended) { ended = true; count--; notify(); } };
    },
  };
}
export const warehouseWrites = createWriteActivity();
